interface FeedbackListResponse {
  payload: {
    count: number;
    feedback: {
      uuid: string;
      accountUuid: string;
      customerUuid: string;
      comment: string;
      feedbackType: string;
      createdAt: string;
      rating: number | null;
      updatedAt: string | null;
    }[];
  };
  message: string;
}

async function getFeedbackList(companyUuid: string, page: number, limit: number, sort: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}hospitality/get-feedback?companyUuid=${companyUuid}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Error fetching feedback list: ${response.statusText}`);
  }

  const feedbackList: FeedbackListResponse = await response.json();
  return feedbackList;
}

export { getFeedbackList };
